import { Routes } from '@angular/router';
import { PageLayoutComponent } from './layout/page-layout/page-layout.component';
import { authGuard } from './core/guard/auth.guard';
import { permissionGuard } from './core/guard/permission.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('../app/modules/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: ':tenantcode',
    component: PageLayoutComponent, // shell layout
    canActivate: [authGuard],
    children: [
      {
        path: 'todos',
        loadComponent: () =>
          import('./modules/workbench/pages/workbench-todos/workbench-todos.component').then(
            (m) => m.WorkbenchTodosComponent
          ),
        // canMatch: [
        //   permissionGuard('todos')
        // ]
      },
      {
        path: 'todos/:chatId',
        loadComponent: () =>
          import('./modules/workbench/pages/workbench-todos/workbench-todos.component').then(
            (m) => m.WorkbenchTodosComponent
          ),
      },
      {
        path: 'workbench',
        loadChildren: () =>
          import('./modules/workbench/workbench.module').then(
            (m) => m.WorkbenchModule
          ),
      },
      // {
      //   path: 'bp-all-submissions',
      //   loadChildren: () =>
      //     import('./modules/bp-all-submissions/bp-all-submissions.module').then(
      //       (m) => m.BpAllSubmissionsModule
      //     ),
      // },
      {
        path: 'bp-all-submissions',
        loadChildren: () =>
          import('./modules/dashboard-management/dashboard-management.module').then(
            (m) => m.DashboardManagementModule
          ),
      },
    ],
  },
  { path: '**', redirectTo: '/' },
];
